import {applyBrand} from '@packages/utilities/type-safety';
import {CodeModuleLoaderConfig, CodeModuleId} from './types';

export function makeCodeModuleId(moduleId: string): CodeModuleId {
  if (!moduleId) {
    throw new Error('Module ID cannot be empty');
  }
  return applyBrand<CodeModuleId>(`_${moduleId}`);
}

export function parseCodeModuleId(moduleId: CodeModuleId): string {
  return applyBrand<CodeModuleId>(moduleId.replace(/^\_/, ''));
}

/**
 * Extracts the moduleId (if any) from the loader config
 * and normalizes it by removing the _ prefix.
 */
export function getCodeModuleId(
  loader: CodeModuleLoaderConfig | undefined | null
): string | null {
  if (loader?.tag === 'FEDERATION') {
    const moduleId = loader.val?.moduleId;
    if (typeof moduleId === 'string') {
      return parseCodeModuleId(moduleId) || null;
    }
  }

  return null;
}
